import {
  CreateUserRequest,
  CreateUserSimpleRequest,
  CreateUserSimpleRequestToJSON,
  CreateUserSimpleResponse,
  CreateUserSimpleResponseFromJSON,
  DeleteUserRequest,
  GetUserRequest,
  HTTPQuery,
  InlineResponse200,
  InlineResponse200FromJSON,
  LendCollectionInfo,
  LendCollectionInfoFromJSON,
  NowStatus,
  NowStatusFromJSON,
  RemindHistory,
  RemindHistoryFromJSON,
  ReserveCancelCollection,
  ReserveCancelCollectionFromJSON,
  ReserveCollection,
  ReserveCollectionFromJSON,
  SearchUsersRequest,
  SearchUsersRequestToJSON,
  UpdateUserRequest,
  User,
  UserFamily,
  UserFamilyFromJSON,
  UserFromJSON,
  SearchUser,
  SearchUserFromJSON,
  UserMemo,
  UserMemoToJSON,
  UserNote,
  UserNoteToJSON,
  UserOfMemosAndNote,
  UserOfMemosAndNoteFromJSON,
  UserOfMemosAndNotes,
  UserOfMemosAndNotesFromJSON,
  UserReserveContact,
  UserReserveContactFromJSON,
  UpdateUserRequestToJSON,
  CreateGroupRequest,
  CreateGroupRequestToJSON,
  UpdateGroupRequest,
  UpdateGroupRequestToJSON,
  UpdateUserMynumbercardRequest,
  UpdateUserMynumbercardRequestToJSON,
  DeleteUserRequestToJSON,
  GetUserOfMemosAndNotesByIdRequest,
  GetUserOfMemosAndNotesByIdRequestToJSON,
  CreateUserRequestToJSON,
  GetUserReserveCollectionsRequest,
  GetUserReserveCollectionsRequestToJSON,
  GetUserRemindHistoriesRequestToJSON,
  GetUserRemindHistoriesRequest,
  GetUserNowStatusRequest,
  GetUserNowStatusRequestToJSON,
  GetUserReserveCancelCollectionsRequest,
  GetUserReserveCancelCollectionsRequestToJSON,
  ReleaseUserMynumbercardRequest,
  ReleaseUserMynumbercardRequestToJSON,
  UpdateUserFelicaIdRequest,
  UpdateUserFelicaIdRequestToJSON,
  ReleaseUserFelicaIdRequest,
  ReleaseUserFelicaIdRequestToJSON,
  GetUserNewExpirationDateRequest,
  GetUserNewExpirationDateRequestToJSON,
  DeleteUserMemoRequest,
  DeleteUserMemoRequestToJSON,
  UserCardReissueRequest,
  UserCardReissueRequestToJSON
} from '@/api'
import * as runtime from '../runtime'

/**
 * no description
 */
export class UserApi extends runtime.BaseAPI {
  async createUserSimple(
    requestParameters: CreateUserSimpleRequest
  ): Promise<CreateUserSimpleResponse> {
    const response = await this.requestPost(
      `/users/simple`,
      CreateUserSimpleRequestToJSON(requestParameters)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      CreateUserSimpleResponseFromJSON(jsonValue)
    ).value()
  }

  async createUser(request: CreateUserRequest): Promise<InlineResponse200> {
    const bodyParameters: runtime.HTTPBody = CreateUserRequestToJSON(request)
    const response = await this.requestPost(`/users`, bodyParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      InlineResponse200FromJSON(jsonValue)
    ).value()
  }

  async updateUser(request: UpdateUserRequest): Promise<InlineResponse200> {
    const bodyParameters: runtime.HTTPBody = UpdateUserRequestToJSON(request)
    const response = await this.requestPut(
      `/users/${request.id}`,
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      InlineResponse200FromJSON(jsonValue)
    ).value()
  }

  async createGroup(request: CreateGroupRequest): Promise<InlineResponse200> {
    const bodyParameters: runtime.HTTPBody = CreateGroupRequestToJSON(request)
    const response = await this.requestPost(`/users/group`, bodyParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      InlineResponse200FromJSON(jsonValue)
    ).value()
  }

  async updateGroup(request: UpdateGroupRequest): Promise<InlineResponse200> {
    const bodyParameters: runtime.HTTPBody = UpdateGroupRequestToJSON(request)
    const response = await this.requestPut(
      `/users/group/${bodyParameters.id}`,
      bodyParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      InlineResponse200FromJSON(jsonValue)
    ).value()
  }

  async deleteUser(
    request: DeleteUserRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = DeleteUserRequestToJSON(request)
    const response = await this.requestDelete(
      `/users/${bodyParameters.id}`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  async searchUsers(request: SearchUsersRequest): Promise<SearchUser[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(SearchUsersRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery

    const response = await this.requestGet(`/users`, queryParameters)

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(SearchUserFromJSON)
    ).value()
  }

  async getUser(request: GetUserRequest): Promise<User> {
    const response = await this.requestGet(`/users/${request.id}`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      UserFromJSON(jsonValue)
    ).value()
  }

  async getUserName(id: string): Promise<string> {
    const response = await this.requestGet(`/users/${id}/name`)
    return new runtime.JSONApiResponse(
      response,
      jsonValue => jsonValue.name
    ).value()
  }

  /**
   * 入力値により利用者のメモと注記を更新する
   * 利用者メモ注記更新
   */
  async updateMemoAndNoteById(
    id: string,
    memos: UserMemo[],
    notes: UserNote[]
  ): Promise<void> {
    const response = await this.requestPost(`/users/${id}/memo`, {
      memos: memos.map(UserMemoToJSON),
      notes: notes.map(UserNoteToJSON)
    })

    return new runtime.VoidApiResponse(response).value()
  }

  /**
   *  利用者IDにより利用者のメモと注記を取得する
   *  利用者メモ注記取得
   */
  async getUserOfMemosAndNotesById(
    request: GetUserOfMemosAndNotesByIdRequest
  ): Promise<UserOfMemosAndNotes> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(GetUserOfMemosAndNotesByIdRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet(`/users/${queryParameters.id}/memo`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      UserOfMemosAndNotesFromJSON(jsonValue)
    ).value()
  }

  /**
   *  利用者IDにより利用者のメモと注記を取得する
   *  利用者メモ注記取得
   */
  async getMemosAndNoteById(id: string): Promise<UserOfMemosAndNote> {
    const response = await this.requestGet(`/users/${id}/memo`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      UserOfMemosAndNoteFromJSON(jsonValue)
    ).value()
  }

  /**
   * 入力条件により、利用者の貸出資料を取得する
   * 利用者貸出資料取得
   */
  async getUserLendCollectionsById(id: string): Promise<LendCollectionInfo> {
    const response = await this.requestGet(`/users/${id}/lend-collections`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      LendCollectionInfoFromJSON(jsonValue)
    ).value()
  }

  /**
   * 入力条件により、利用者の督促履歴を取得する
   * 利用者督促履歴取得
   */
  async getUserRemindHistoriesById(
    request: GetUserRemindHistoriesRequest
  ): Promise<RemindHistory[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(GetUserRemindHistoriesRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet(
      `/users/${queryParameters.id}/remind-histories`
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(RemindHistoryFromJSON)
    ).value()
  }

  /**
   * 入力条件により、利用者の督促履歴を取得する
   * 利用者督促履歴取得
   */
  async getRemindHistory(id: string): Promise<RemindHistory[]> {
    const response = await this.requestGet(`/users/${id}/remind-histories`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(RemindHistoryFromJSON)
    ).value()
  }

  /**
   * 入力条件により、利用者の利用状況を取得する
   * 利用者督促履歴取得
   */
  async getUserNowStatusById(
    request: GetUserNowStatusRequest
  ): Promise<NowStatus> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(GetUserNowStatusRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet(
      `/users/${queryParameters.id}/now-status`
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      NowStatusFromJSON(jsonValue)
    ).value()
  }

  /**
   * 入力条件により、利用者の予約取消資料を取得する
   * 利用者予約取消資料取得
   */
  async getUserReserveCancelCollectionsById(
    request: GetUserReserveCancelCollectionsRequest
  ): Promise<ReserveCancelCollection[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(
        GetUserReserveCancelCollectionsRequestToJSON(request)
      ).filter(value => value[1] !== undefined)
    ) as HTTPQuery
    const response = await this.requestGet(
      `/users/${queryParameters.id}/reserve-cancel-collections`
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(ReserveCancelCollectionFromJSON)
    ).value()
  }

  /**
   * 入力条件により、利用者の督促履歴を取得する
   * 利用者督促履歴取得
   */
  async getUserReserveCollections(
    request: GetUserReserveCollectionsRequest
  ): Promise<ReserveCollection[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(GetUserReserveCollectionsRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet(
      `/users/${queryParameters.id}/reserve-collections`
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(ReserveCollectionFromJSON)
    ).value()
  }

  async getUsersFamily(id: string): Promise<UserFamily[]> {
    const response = await this.requestGet(`/users/${id}/families`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(UserFamilyFromJSON)
    ).value()
  }

  async getUserNewExpirationDate(
    request: GetUserNewExpirationDateRequest
  ): Promise<string> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(GetUserNewExpirationDateRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery

    const response = await this.requestGet(
      `/users/new-expiration-date`,
      queryParameters
    )

    return new runtime.JSONApiResponse(
      response,
      jsonValue => jsonValue.expiration_date
    ).value()
  }

  async resetOpacPassword(userId: string): Promise<string> {
    const response = await this.requestPut(`/users/${userId}/opac-password`)

    return new runtime.JSONApiResponse(
      response,
      jsonValue => jsonValue.password
    ).value()
  }

  async userCardReissue(request: UserCardReissueRequest): Promise<string> {
    const bodyParameters: runtime.HTTPBody = UserCardReissueRequestToJSON(
      request
    )

    const response = await this.requestPut(
      `/users/${request.id}/user-card-reissue`,
      bodyParameters
    )

    return new runtime.JSONApiResponse(
      response,
      jsonValue => jsonValue.password
    ).value()
  }

  async integrate(userId: string, targetUserId: string) {
    const response = await this.requestPut(`/users/${userId}/integrate`, {
      target_user_id: targetUserId
    })

    return new runtime.VoidApiResponse(response)
  }

  async getUserReserveContact(id: string): Promise<UserReserveContact> {
    const response = await this.requestGet(`/users/${id}/reserve-contacts`)

    return new runtime.JSONApiResponse(response, jsonValue =>
      UserReserveContactFromJSON(jsonValue)
    ).value()
  }

  async releaseUserMynumbercard(
    request: ReleaseUserMynumbercardRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = ReleaseUserMynumbercardRequestToJSON(
      request
    )

    const response = await this.requestPost(
      `/users/${bodyParameters.id}/mynumbercard`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  async updateUserMynumbercard(
    request: UpdateUserMynumbercardRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateUserMynumbercardRequestToJSON(
      request
    )

    const response = await this.requestPost(
      `/users/${bodyParameters.id}/update-mynumbercard`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  async updateUserFelicaId(
    request: UpdateUserFelicaIdRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateUserFelicaIdRequestToJSON(
      request
    )

    const response = await this.requestPost(
      `/users/${bodyParameters.id}/felica-id`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  async releaseUserFelicaId(
    request: ReleaseUserFelicaIdRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = ReleaseUserFelicaIdRequestToJSON(
      request
    )

    const response = await this.requestDelete(
      `/users/${bodyParameters.id}/felica-id`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  async deleteUserMemo(
    request: DeleteUserMemoRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = DeleteUserMemoRequestToJSON(
      request
    )
    const response = await this.requestDelete(
      `/users/${bodyParameters.id}/memo`,
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }

  async getUserNextId(): Promise<string> {
    const response = await this.requestGet(`/users/next-id`)

    return new runtime.JSONApiResponse(
      response,
      jsonValue => jsonValue.id
    ).value()
  }
}
